"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeWrapper = DateRangeWrapper;
var _react = _interopRequireDefault(require("react"));
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var _reactDateRange = require("react-date-range");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DateRangeWrapper(_ref) {
  var selectionRate = _ref.selectionRate,
    onChangeRange = _ref.onChangeRange,
    locale = _ref.locale;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactDateRange.DateRange, {
    ranges: [selectionRate],
    onChange: onChangeRange,
    locale: locale
  }));
}